<nz-select (ngModelChange)="writeValue($event)" [(ngModel)]="value" [disabled]="disabled" [nzAllowClear]="allowClear"
           [nzMaxTagCount]="maxTagCount"
           [nzMaxTagPlaceholder]="tagPlaceHolder"
           [nzMode]="mode" [nzPlaceHolder]="placeholder" [nzShowSearch]="showSearch">
    <nz-option *ngFor="let device of options" [nzLabel]="device.deviceName" [nzValue]="getValue(device)"></nz-option>
</nz-select>
<ng-template #tagPlaceHolder let-selectedList>+{{ selectedList.length }}</ng-template>
